import React from "react";
import PropTypes from "prop-types";
import "../css/ExpoMobile.css";
import Image from "./ImageElement";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import shuffle from 'shuffle-array';
import ExpoMethods from "./ExpoMethods";
/**
 * ExpoMobile component
 */
class ExpoMobile extends ExpoMethods {
  static displayName = "ExpoMobile";
  static propTypes = {
    className: PropTypes.string,
    tag: PropTypes.string.isRequired,
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "ExpoMobile";
    this.imageBlock = this.imageBlock.bind(this);
    this.projects = this.projects.bind(this);
    this.filterByTag = this.filterByTag.bind(this);
    this.projectsList = this.projects();
  }

  /**
   * @override
   */
  render() {
    const projects = this.projectsList;
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <div className={`${this.className}__cols`}>
          <div className={`${this.className}__col `}>
            {this.projects().map(this.imageBlock)}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ExpoMobile);
